// import { useState } from 'react';

import { Box, Typography, useTheme } from 'hephaestus/web';
import { useLocalization } from '../../../../hooks/useLocalization';

const Step = ({
  step,
  workflowCompletion,
}: {
  step: any;
  workflowCompletion: any;
}) => {
  const theme = useTheme();
  const isActive = step?.id === workflowCompletion.currentStep.id;
  const currentActiveStepIndex =
    workflowCompletion?.workflow?.steps?.findIndex(
      (s: any) => s?.id === workflowCompletion?.currentStep?.id,
    ) || 0;
  const currentStepIndex =
    workflowCompletion?.workflow?.steps?.findIndex(
      (s: any) => s?.id === step?.id,
    ) || 0;
  const currentSubStepIndex =
    workflowCompletion?.currentStep?.subSteps?.findIndex(
      (subStep: any) => subStep?.id === workflowCompletion?.currentSubStep?.id,
    ) || 0;
  const completionPercentage = currentSubStepIndex / step.subSteps.length;

  return (
    <>
      <div
        style={{
          width: '6px',
          height: '6px',
          marginRight: '8px',
          borderRadius: theme.borderRadius.round,
          backgroundColor:
            currentStepIndex < currentActiveStepIndex
              ? theme.color.primary
              : theme.color.primaryVariantHover,
          flex: isActive ? 1 : undefined,
          transition: 'all 0.5s ease-in-out',
        }}
      >
        {isActive && !workflowCompletion.workflow.complex && (
          <div
            style={{
              height: '100%',
              width: `${completionPercentage * 100}%`,
              backgroundColor: theme.color.primary,
              borderRadius: theme.borderRadius.round,
              transition: 'width 0.5s ease-in-out',
            }}
          ></div>
        )}
      </div>
    </>
  );
};
export const StepIndicator = ({
  workflowCompletion,
}: {
  workflowCompletion: any;
}) => {
  const { translateBackendString } = useLocalization();
  const currentStepIndex =
    workflowCompletion?.workflow?.steps?.findIndex(
      (s: any) => s?.id === workflowCompletion?.currentStep?.id,
    ) || 0;
  const componentProps =
    workflowCompletion?.currentSubStep?.options?.componentProps || {};

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end',
        position: 'relative',
        mb: 4,
        width: '275px',
        ...componentProps,
      }}
    >
      <Typography
        variant='labelSmall'
        sx={{
          position: 'absolute',
          top: '-26px',
          left: `${currentStepIndex * 14}px`,
          transition: 'all 0.5s ease-in-out',
          whiteSpace: 'nowrap',
        }}
      >
        {translateBackendString(workflowCompletion?.currentStep?.name || '')}
      </Typography>
      {workflowCompletion?.workflow?.steps?.map((step: any) => (
        <Step
          step={step}
          workflowCompletion={workflowCompletion}
          key={step.id}
        />
      ))}
    </Box>
  );
};
